import { z } from 'zod';

const packagingMasterDataBaseSchema = z.object({
    code: z.string(),
    description: z.string().nullish(),
});

const packagingMasterDataPackagingItemSchema = packagingMasterDataBaseSchema;

const packagingMasterDataItemSearchResultSchema = packagingMasterDataPackagingItemSchema.extend({
    type: z.literal('item'),
});

const packagingMasterDataBundleItemSchema = z.object({
    quantity: z.number().int().positive(),
    packaging_item: packagingMasterDataPackagingItemSchema,
});

const packagingMasterDataBundleSearchResultSchema = packagingMasterDataBaseSchema.extend({
    type: z.literal('bundle'),
    items: z.array(packagingMasterDataBundleItemSchema),
});

export const packagingMasterDataSearchResponseSchema = z.object({
    items: z.array(
        z.discriminatedUnion('type', [
            packagingMasterDataItemSearchResultSchema,
            packagingMasterDataBundleSearchResultSchema,
        ])
    ),
});

export type ApiPackagingMasterDataSearchResponse = z.infer<typeof packagingMasterDataSearchResponseSchema>;
export type ApiPackagingMasterDataSearchResult = ApiPackagingMasterDataSearchResponse['items'][number];
